module.exports = __webpack_public_path__ + "img/video-script-icon.46dd5b75.svg";